function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 1
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.4058 3.57556C5.78112 5.11142 3.95837 7.75689 3.95837 11.2533C3.95837 14.3204 6.62438 16.875 10 16.875C13.3757 16.875 16.0417 14.3204 16.0417 11.2533C16.0417 8.53066 14.6425 6.34588 13.5624 5.18803C13.2352 5.88069 12.7632 6.68797 12.167 7.35624C11.5192 8.08244 10.6381 8.73854 9.56446 8.75473C8.83677 8.83687 7.92757 8.54884 7.43843 7.54082C7.02474 6.68831 6.96046 5.41035 7.4058 3.57556ZM8.41443 2.06812C8.75111 2.31342 8.92851 2.75895 8.79587 3.21507C8.17662 5.34449 8.30424 6.46185 8.56301 6.99511C8.78816 7.45908 9.14945 7.54958 9.44093 7.51056L9.48221 7.50504H9.52385C10.0895 7.50504 10.6717 7.15468 11.2343 6.5241C11.7859 5.90576 12.2342 5.1093 12.5294 4.44138C12.8008 3.82732 13.6661 3.52141 14.2421 4.09348C15.4828 5.32567 17.2917 7.91277 17.2917 11.2533C17.2917 15.0861 13.9882 18.125 10 18.125C6.0119 18.125 2.70837 15.0861 2.70837 11.2533C2.70837 6.84063 5.27194 3.67386 7.1758 2.11283C7.56677 1.79226 8.06608 1.81431 8.41443 2.06812Z",
  fill: "currentColor"
}));

function SvgFuelingManager({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelingManager);
export default __webpack_public_path__ + "static/media/fueling-manager.41c251d3.svg";
export { ForwardRef as ReactComponent };